var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMetricsBrightness = function SvgMetricsBrightness(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0h3v5.959h-3zm0 42.041h3V48h-3zM0 22.5h5.959v3H0zm42.041 0h5.958v3h-5.958zM5.97 8.09l2.12-2.122 4.214 4.214-2.121 2.122zm29.726 29.727 2.122-2.121 4.213 4.214-2.121 2.121zM5.969 39.91l4.214-4.214 2.121 2.121-4.214 4.214zm29.727-29.727 4.214-4.214 2.12 2.121-4.213 4.214zM37.479 24l-3.948-9.531-6.354-2.632L24 10.521l-9.531 3.948L10.521 24l3.948 9.531L24 37.479l9.531-3.948zm-20.714 7.235-3-7.235 3-7.235 7.235-3v20.467z"
  })));
};
export default SvgMetricsBrightness;